import { Globe, Smartphone, Briefcase, Building2, Rocket, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { WHAT_WE_BUILD } from "../../data/content";

const ICONS = { web: Globe, mobile: Smartphone, business: Briefcase, enterprise: Building2, mvp: Rocket };

export default function WhatWeBuild() {
  return (
    <section id="what-we-build" className="py-24 lg:py-36 border-t border-white/5 scroll-mt-24" data-testid="what-we-build-section">
      <div className="container-x">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <div>
            <p className="section-label">WHAT WE BUILD</p>
            <h2 className="mt-5 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white">
              IF YOUR BUSINESS RUNS ON IT,<br />WE CAN <span className="text-flame">BUILD IT.</span>
            </h2>
          </div>
          <Link to="/get-estimate" data-testid="wwb-estimate-link" className="inline-flex items-center gap-2 text-sm font-heading font-bold text-flame hover:gap-3 transition-all shrink-0">
            GET AN ESTIMATE <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-5">
          {WHAT_WE_BUILD.map((c) => {
            const Icon = ICONS[c.key];
            return (
              <div
                key={c.key}
                data-testid={`wwb-card-${c.key}`}
                className={`${c.span} rounded-2xl border border-white/10 bg-navy-800 p-8 sm:p-10 card-lift group`}
              >
                <div className="flex items-start justify-between">
                  <Icon className="w-7 h-7 text-flame" />
                  <ArrowUpRight className="w-5 h-5 text-slate-600 group-hover:text-flame transition-colors" />
                </div>
                <h3 className="mt-6 font-heading text-xl sm:text-2xl font-bold tracking-tight text-white">{c.title}</h3>
                <p className="mt-2 text-sm text-slate-400">{c.desc}</p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {c.items.map((i) => (
                    <span key={i} className="rounded-full border border-white/10 bg-navy-900/60 px-3.5 py-1.5 text-[11px] font-medium tracking-wide text-slate-300">
                      {i}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
